<h2 mat-dialog-title>
  {{ 'APP.ARCHIVE.INSERT_INTO_ACT.TITLE' | translate }}
</h2>

<mat-dialog-content class="adf-insert-into-act-dialog-content">
  <form [formGroup]="archiveForm" novalidate>
    <mat-form-field appearance="standard">
      <mat-label>{{ 'APP.ARCHIVE.REGISTRY_BOOK' | translate }}</mat-label>
      <mat-select formControlName="selectedRegistry" required>
        <mat-option *ngFor="let registry of registries" [value]="registry.nodeRef">{{ registry.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="selectedRegistry.invalid">{{ 'APP.ARCHIVE.ERROR.REQUIRED' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="standard" required>
      <mat-label>{{ 'APP.ARCHIVE.INVENTORY_OF_ACTS' | translate }}</mat-label>
      <mat-select formControlName="selectedInventoryOfActs" required>
        <mat-option *ngFor="let inventory of inventoriesOfActs" [value]="inventory.nodeRef">{{ inventory.title }}</mat-option>
      </mat-select>
      <mat-error *ngIf="selectedInventoryOfActs.invalid">{{ 'APP.ARCHIVE.ERROR.REQUIRED' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{ 'APP.ARCHIVE.SEQUENTIAL_INDEX' | translate }}</mat-label>
      <input matInput formControlName="sequentialIndex" name="index" type="number" inputmode="numeric" min="1" />
      <mat-error *ngIf="sequentialIndex.errors?.min">{{ 'APP.ARCHIVE.ERROR.NEGATIVE_VALUE' | translate }}</mat-error>
      <mat-error *ngIf="sequentialIndex.errors?.invalidIndex">{{ 'APP.ARCHIVE.ERROR.INDEX_INVALID' | translate }}</mat-error>
    </mat-form-field>
    <div *ngIf="selectedAct" class="results-preview">
      {{ printSelectedAct() }}
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="adf-dialog-buttons">
  <span class="adf-fill-remaining-space"></span>

  <button
    mat-button
    class="adf-dialog-action-button"
    color="primary"
    (click)="insertIntoAct()">
    {{ 'APP.ARCHIVE.INSERT_INTO_ACT.INSERT' | translate }}
  </button>
  <button
    mat-button
    mat-dialog-close>
    {{ 'APP.GENERAL.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
